import * as zod from "zod/v4";

const SlackChannelSchema_ = zod.object({
  id: zod.string(),
  name: zod.string(),
  isPrivate: zod.boolean(),
  memberCount: zod.number().optional(),
});

export const SlackChannelSchema: zod.ZodType<SlackChannel> =
  SlackChannelSchema_;
export interface SlackChannel extends zod.infer<typeof SlackChannelSchema_> {}

export const searchSlackChannels = {
  name: "searchSlackChannels" as const,
  input: zod.object({ query: zod.string() }),
  output: zod.object({ channels: zod.array(SlackChannelSchema) }),
};
